export enum EDialogType {
  CONFIRM = "CONFIRM",
  ALERT = "ALERT",
}

export interface IDialogBase {
  component?: React.ReactNode;
  text?: string;
  type?: EDialogType;
  title?: string;

  labelApprove?: string;
  labelCancel?: string;
  onApprove?: () => void;
  onCancel?: () => void;
}

export interface ITypedDialog extends IDialogBase {
  type: EDialogType;
}

export interface IDialog extends ITypedDialog {
  id: string;
}

export interface IDialogsActions {
  confirmDialog: (dialog: IDialogBase) => void;
  alertDialog: (dialog: IDialogBase) => void;
  deleteDialog: (dialog: IDialog) => void;
}

export interface IDialogsContext extends IDialogsActions {
  dialogs: IDialog[];
}
